/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Resource type identifier combining cloud provider and service type. `RESOURCE_TYPE_UNSPECIFIED` is supported only in responses. 
*/
export enum ResourceType {
  AwsEc2 = 'AWS_EC2',
  AwsRds = 'AWS_RDS',
  AwsS3 = 'AWS_S3',
  AwsEfs = 'AWS_EFS',
  AwsFsx = 'AWS_FSX',
  AwsEksNamespace = 'AWS_EKS_NAMESPACE',
  AwsDynamoDb = 'AWS_DYNAMO_DB',
  AwsEbsVolume = 'AWS_EBS_VOLUME',
  AwsKeyspacesTable = 'AWS_KEYSPACES_TABLE',
  AwsRedshift = 'AWS_REDSHIFT',
  AzureVirtualMachine = 'AZURE_VIRTUAL_MACHINE',
  AzureFileShare = 'AZURE_FILE_SHARE',
  AzureStorageAccount = 'AZURE_STORAGE_ACCOUNT',
  AzureDisk = 'AZURE_DISK',
  AzureSqlDatabase = 'AZURE_SQL_DATABASE',
  AzureSqlManagedInstance = 'AZURE_SQL_MANAGED_INSTANCE',
  AzureSqlVirtualMachine = 'AZURE_SQL_VIRTUAL_MACHINE',
  AzureSapHanaVm = 'AZURE_SAP_HANA_VM',
  AzureMysql = 'AZURE_MYSQL',
  AzurePostgresql = 'AZURE_POSTGRESQL',
  AzureCosmosdbMongodb = 'AZURE_COSMOSDB_MONGODB',
  AzureCosmosdbNosql = 'AZURE_COSMOSDB_NOSQL',
  AzureAksNamespace = 'AZURE_AKS_NAMESPACE',
  AtlasMongodbCluster = 'ATLAS_MONGODB_CLUSTER',
  GcpComputeEngineInstance = 'GCP_COMPUTE_ENGINE_INSTANCE',
  GcpCloudSqlInstance = 'GCP_CLOUD_SQL_INSTANCE',
  GcpCloudStorageBucket = 'GCP_CLOUD_STORAGE_BUCKET',
  GcpGkeNamespace = 'GCP_GKE_NAMESPACE',
  GcpBigQuery = 'GCP_BIG_QUERY',
  GcpCloudFirestore = 'GCP_CLOUD_FIRESTORE',
  GcpDisk = 'GCP_DISK',
  ResourceTypeUnspecified = 'RESOURCE_TYPE_UNSPECIFIED'
}
